import util from '@/util'
import { obterIcone } from '@/util/imagem'
import constants from '@/util/constants'

export default {
  name: 'resumo',
  components: {
  },
  props: {
    pedidos: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      default: 0
    },
    itens_proporcional: {
      type: Array,
      default: []
    },
    cupom_selecionado: {
      type: Object,
      default: null
    },
    dataVencimento: String,
    default: ''
  },

  computed: {
  },
  data: () => {
    return {
    }
  },
  created () {
  },

  methods: {
    ehProdutoMirt (id) {
      return id === constants.idProdutoMirt
    },
    obterIcone (icone) {
      return obterIcone(icone)
    },
    formatarValorMonetario (valor) {
      if (util.valorEhNulo(valor)) return 'R$ 0'
      return util.formatarValorMonetarioComCifrao(valor)
    },
    obterTotalComDesconto () {
      const desconto = 0
      const total = this.total
      if (total === 0) return
      return total - desconto
    },
    obterTotalPorPedido (pedido) {
      return pedido.valor * pedido.quantidade
    },
    obterTotalGeralPedidos () {
      return this.pedidos.reduce((total, pedido) => {
        const totalPorPedido = this.obterTotalPorPedido(pedido)
        return total + totalPorPedido
      }, 0)
    },
    ehProporcional (indice, pedido) {
      if (this.itens_proporcional.length > 0) {
        if (this.itens_proporcional.filter(item => item.plano_id === pedido.plano_id).length > 0) {
          return this.itens_proporcional.filter(item => item.plano_id === pedido.plano_id)[0].proporcional
        }
      }
    }
  }
}
